import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ff7257d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slider_box" }
const _hoisted_2 = {
  key: 0,
  class: "input"
}
const _hoisted_3 = { class: "input_field_wrap" }
const _hoisted_4 = { class: "slider" }

import InputField from '@/components/atoms/InputField.vue'
import { computed, withDefaults } from 'vue'

type PropsType = {
  modelValue?: number | []
  disabled?: boolean
  inputText?: string
  useInput?: boolean
  min?: number
  max?: number
  formatTooltip?: (v: string | number) => string | number
  step?: number
  range?: boolean
  showTooltip?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Slider',
  props: {
    modelValue: { default: 0 },
    disabled: { type: Boolean, default: false },
    inputText: { default: '' },
    useInput: { type: Boolean, default: false },
    min: { default: 0 },
    max: { default: 100 },
    formatTooltip: null,
    step: { default: 1 },
    range: { type: Boolean, default: false },
    showTooltip: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: number | []): void
  (e: 'change', value: number | []): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number | [], disabled: boolean, inputText: string, useInput: boolean, min: number, max: number, formatTooltip?: (v: string | number) => string | number, step: number, range: boolean, showTooltip: boolean };





const selectedValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change', value)
  },
})

return (_ctx: any,_cache: any) => {
  const _component_el_slider = _resolveComponent("el-slider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.useInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(InputField, {
              modelValue: _unref(selectedValue),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("span", null, _toDisplayString(__props.inputText), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_slider, {
        modelValue: _unref(selectedValue),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null)),
        disabled: __props.disabled,
        max: __props.max,
        min: __props.min,
        formatTooltip: __props.formatTooltip,
        step: __props.step,
        range: __props.range,
        showTooltip: __props.showTooltip
      }, null, 8, ["modelValue", "disabled", "max", "min", "formatTooltip", "step", "range", "showTooltip"])
    ])
  ]))
}
}

})